module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABYSURBVDhPY2Qo8zrMoCJuw0AOuPPyCCPDrMT/UC5ZgAlKkw3gLvifOg8sQCxgnJ0EofF5AWYoTDE2QLEXRg0YDAYwgNIBuQCkd+DzAhMoS0LZpIM7r44CAHbjU1WCB3VlAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/online_tools_logo.png
// module id = kPTK
// module chunks = 2